import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!sessionStorage.getItem("authToken"));

  useEffect(() => {
    const checkAuth = () => {
      setIsLoggedIn(!!sessionStorage.getItem("authToken"));
    };

    window.addEventListener("storage", checkAuth);
    return () => window.removeEventListener("storage", checkAuth);
  }, []);

  const login = (token) => {
    sessionStorage.setItem("authToken", token);
    sessionStorage.setItem("loginTime", new Date().toISOString());
  
    setIsLoggedIn(true); // ✅ Ensure state updates immediately
  };

  const logout = () => {
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("loginTime");
    sessionStorage.removeItem("userRole");

    // ✅ Ensure state updates immediately
    setIsLoggedIn(false);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
